import { useGetRegionPageAvailableVideos } from 'api/regions/hooks';
import { useFetchLocationAvailableVideos } from 'api/locations/hooks';
import { useFetchRetailerPageAvailableVideos, useFetchStore } from 'api/store/hooks';
import { useParams } from 'react-router-dom';
import { useSelectedProfileStore } from 'stores/selectedProfileStore';

export const useLocationVideoAvailableItems = () => {
  const { locationUid } = useParams();
  const { data, isLoading } = useFetchLocationAvailableVideos(locationUid);

  return { items: data || [], isLoading };
};

export const useStoreVideoAvailableItems = () => {
  const { data: store } = useFetchStore();
  const { data, isLoading } = useFetchRetailerPageAvailableVideos(store?.uid, {
    enabled: !!store?.uid,
  });

  return { items: data || [], isLoading };
};

export const useRegionVideoAvailableItems = () => {
  const selectedRegion = useSelectedProfileStore((state) => state.selectedRegionUid);
  const { data, isLoading } = useGetRegionPageAvailableVideos(selectedRegion);

  return { items: data || [], isLoading };
};
